import type { PayloadAction } from '@reduxjs/toolkit';
import { updateAndAssignSnapQuote } from '@ui/features/quote-builder/state/endpoints/update-and-assign-snap-quote';
import type { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import type { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

/**
 * After successfully updating the quote and creating a new assignment, update
 * the `currentAssignment` in quote builder state to reflect the newly created
 * assignment.
 */
function updateAndAssignQuoteFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof updateAndAssignSnapQuote.Types.ResultType>,
) {
  state.currentAssignment = action.payload;
}

export function updateAndAssignQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    updateAndAssignSnapQuote.matchFulfilled,
    updateAndAssignQuoteFulfilled,
  );
}
